
import { VehicleStatus } from "static/js/app/models/__index";
export class GetVehicleTypesOptions {
    constructor(
        public vehicleStatus: VehicleStatus = "used",
        public availability: string = "available",
        
    ) { }
}